"use strict";
// import getElemDistance from './src/helpers.js'; // relative path helps webpack resolve
import Debounce from "./debounce.js"; // relative path helps webpack resolve
// import Glide from '@glidejs/glide';

// importing swiper adds ~140k right away to minified file, which is otherwise pulled from CDN and likely already cached
// import Swiper from 'swiper';
// import { Navigation, Pagination, Scrollbar } from 'swiper/modules';

/**
 * Debounce functions for better performance
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Function} fn The function to debounce
 */
var debounce = function (fn) {
  // Setup a timer
  var timeout;

  // Return a function to run debounced
  return function () {
    // Setup the arguments
    var context = this;
    var args = arguments;

    // If there's a timer, cancel it
    if (timeout) {
      window.cancelAnimationFrame(timeout);
    }

    // Setup the new requestAnimationFrame()
    timeout = window.requestAnimationFrame(function () {
      fn.apply(context, args);
    });
  };
};

/***************************
 * scripts.js
 * globals, for use in common and unique script documents
 * from http://stackoverflow.com/a/7048295
 ***************************/
var sm = 768;
var lg = 1152;
site.breakSm = 768;
site.breakLg = 1480;
site.isMobile;
site.isDesktop;
site.isMassive;

site.screenWidth = site.getWidth();
site.screenHeight = site.getHeight();

site.googleMap; // global so can set zoom level on mobile
site.markers = []; // save for clustering

// // for getting colors from sass, from https://github.com/malyw/sass-to-js
// var colorsEl = $('.color-data');

/**
 * Get header height
 * for correct positioning of interior anchors
 **/
// set anchor height
let secondaryResourceWrapper = document.getElementById(
  "secondary-resource-section"
);
if (secondaryResourceWrapper) {
  // console.log('secondaryResourceWrapper', secondaryResourceWrapper);
  secondaryResourceWrapper.style["scroll-margin-top"] =
    site.headerHeight + "px";
}

/**********
 * Check Mobile every time resize the browser
 **********/
// set mobile flag
function checkMobile() {
  site.screenWidth = site.getWidth();
  // only do it if already not mobile or initial
  if (site.screenWidth < site.breakSm) {
    // set flags
    site.isMobile = true;
    site.isTablet = false;
    site.isDesktop = false;
    site.isMassive = false;

    // only check if already mobile and bigger
    // Tablet
  } else if (
    site.screenWidth > site.breakSm &&
    site.screenWidth <= site.breakMd
  ) {
    // set flags
    site.isMobile = false;
    site.isTablet = true;
    site.isDesktop = false;
    site.isMassive = false;

    // Desktop
  } else if (
    site.screenWidth > site.breakMd &&
    site.screenWidth <= site.breakLg
  ) {
    // set flags
    site.isMobile = false;
    site.isTablet = false;
    site.isDesktop = true;
    site.isMassive = false;
  } else if (site.screenWidth > site.breakLg) {
    // set flag
    site.isMobile = false;
    site.isTablet = false;
    site.isDesktop = false;
    site.isMassive = true;
  }
}

checkMobile(); // initial

/*****
 * Get url params
 * from https://stackoverflow.com/a/901144
 * usage /us?cities=off
 *****/
function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/**
 * forEach helper method
 * from https://gomakethings.com/a-vanilla-js-foreach-helper-method/
 **/
var forEach = function (arr, callback) {
  Array.prototype.forEach.call(arr, callback);
};

/*
 * get parent with class helper
 * from https://gomakethings.com/how-to-get-the-closest-parent-element-with-a-matching-selector-using-vanilla-javascript/
 */

var getClosest = function (elem, selector) {
  // Element.matches() polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function (s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {}
        return i > -1;
      };
  }

  // Get the closest matching element
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.matches(selector)) return elem;
  }
  return null;
};

/**
 * Debounce functions for better performance
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Function} fn The function to debounce
 */
var debounce = function (fn) {
  // Setup a timer
  var timeout;

  // Return a function to run debounced
  return function () {
    // Setup the arguments
    var context = this;
    var args = arguments;

    // If there's a timer, cancel it
    if (timeout) {
      window.cancelAnimationFrame(timeout);
    }

    // Setup the new requestAnimationFrame()
    timeout = window.requestAnimationFrame(function () {
      fn.apply(context, args);
    });
  };
};

/*********
 * svg4everybody
 * makes svgs work in ie, from https://github.com/jonathantneal/svg4everybody
 *********/

/**
 * After all things load...
 * new way from fullcalendar and @James
 **/
// $(document).ready(function() {
document.addEventListener("DOMContentLoaded", function () {
  /*
   * Staff Intranet reveal
   */
  let resources = document.querySelectorAll(".resource");

  // help clear
  let secondaryResourceWrapper = document.querySelector(
    ".secondary-tertiary-resource-wrapper"
  );

  /********************
   * External links to new tab
   * from https://forum.getkirby.com/t/open-link-in-new-tab-button-for-non-coders/3151/15?u=lukehatfield
   ********************/
  let links = document.querySelectorAll("a");

  forEach(links, function (link) {
    if (link.host !== window.location.host && link.host != "") {
      console.log("found external link!");
      link.setAttribute("target", "_blank");
    }
  });

  /**
   * navigation
   **/

  // desktop dropdown

  // nav check
  var navParents = document.querySelectorAll(".nav-parent");

  /**
   * all click listeners for performance
   * from https://gomakethings.com/why-event-delegation-is-a-better-way-to-listen-for-events-in-vanilla-js/
   **/
  document.addEventListener(
    "click",
    function (event) {
      // console.log("heard a click", event);

      // close map highlight
      let interactiveSVGMap = event.target.closest("svg.interactive-map-svg");
      if (interactiveSVGMap) {
        if (event.target.matches(".rd")) {
          // just open the highlight in interactive-map.php script
        } else {
          // close the highlight if click outside red path
          // console.log("close highlight");
          document.body.classList.remove("body-show-highlight");
        }
      }

      /*****
       * * Nav
       *****/
      // if nav already showing, continue to other pages
      let navParent = event.target.closest(".nav-parent");
      if (navParent) {
        if (navParent.classList.contains("show-dropdown")) {
          // console.log("follow this link!");
          return;
        } else if (site.isMobile) {
          event.preventDefault();
        }
      }

      // hide other dropdowns, using helper script from above
      forEach(navParents, function (navParent) {
        // let thisNavParent = event.target.closest(".nav-parent");
        navParent.classList.remove("show-dropdown");
      });

      // dropdown nav
      // if (event.target.matches(".nav-parent")) {
      if (event.target.matches(".nav-parent-link-inner")) {
        event.target.closest(".nav-parent").classList.add("show-dropdown");
      }

      // // blog article reveal
      // if (event.target.matches('.blog-post-picture-wrapper, .blog-post-no-picture-wrapper')) {
      //   event.target.classList.toggle('show-article');
      // }

      // secondary resource reveal
      if (event.target.matches(".resource .aside-button")) {
        // console.log('show resource');

        // event.target.classList.add('show-secondary-resources');
        // get parent resource, from https://gomakethings.com/how-to-get-the-closest-parent-element-with-a-matching-selector-using-vanilla-javascript/
        let resource = getClosest(event.target, ".resource");
        // console.log(resource);

        // get nth index of current resource, from https://stackoverflow.com/a/49620298/4504073
        let resourceIndex = Array.from(resources).indexOf(resource);
        // console.log(resourceIndex);

        // clear tertiary reveal
        secondaryResourceWrapper.classList =
          "core-inner secondary-tertiary-resource-wrapper";

        // do main reveal
        let main = document.getElementsByTagName("main")[0];
        // console.log(main);

        // add class so secondary resources reveal
        main.classList = "intranet-main show-secondary-" + resourceIndex;

        // check mobile, and smooth scroll
        if (site.isMobile) {
          let anchor = document.querySelector("#secondary-resource-section");
          anchor.scrollIntoView();
        }
      }

      // tertiary resource reveal
      if (event.target.matches(".resource-link")) {
        // add class to common parent
        let wrapper = getClosest(
          event.target,
          ".secondary-tertiary-resource-wrapper"
        );
        // console.log('wrapper', wrapper);

        // get current item in list to compare to siblings for index #
        let resourceItem = getClosest(event.target, ".resource-item");
        // console.log('resourceItem', resourceItem);

        let resourceCategoryList = getClosest(
          event.target,
          ".resource-category-list"
        ).querySelectorAll(".resource-item");
        console.log("resourceCategoryList", resourceCategoryList);

        // get nth index of current resource, from https://stackoverflow.com/a/49620298/4504073
        let resourceItemIndex =
          Array.from(resourceCategoryList).indexOf(resourceItem);
        console.log(resourceItemIndex);
        console.log("resourceItemIndex", resourceItemIndex);

        // remove reveal, if not an external link or already showing yourself
        if (
          event.target.hasAttribute("target") ||
          wrapper.classList.contains("show-tertiary-" + resourceItemIndex)
        ) {
          console.log("hide pink");
          // hide pink for external links
          wrapper.classList = "core-inner secondary-tertiary-resource-wrapper";
        } else {
          // remove any sibling visibility
          wrapper.classList = "core-inner secondary-tertiary-resource-wrapper";
          // reveal yourself
          wrapper.classList.add("show-tertiary-" + resourceItemIndex);
        }
      }

      // mobile nav
      if (event.target.matches("#nav-icon-wrapper")) {
        console.log("show nav");
        document.body.classList.toggle("show-nav");
      }
    },
    false
  );

  /**********
   * nav search
   **********/
  let searchIcon = document.querySelector("#search-icon");
  if (searchIcon) {
    searchIcon.addEventListener("click", function () {
      document.body.classList.toggle("show-search-bar");
    });
  } else {
    console.log("no search!");
  }

  /**********
   * home topper swiper
   **********/
  const homeTopperSwiper = new Swiper(".home-topper-swiper", {
    keyboard: {
      enabled: true,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    autoplay: {
      delay: 4000,
      // disableOnInteraction: true,
    },
  });

  /**********
   * home features swiper
   **********/

  // home swiper thumbnail controls
  const homeThumbsSwiper = new Swiper(".home-thumbs-swiper", {
    rewind: true, // animate go to beginning
    slidesPerView: 3,
    keyboard: {
      enabled: true,
    },
  });

  const homeSwiper = new Swiper(".home-swiper", {
    rewind: true, // animate go to beginning
    keyboard: {
      enabled: true,
    },
    autoHeight: true,

    thumbs: {
      swiper: homeThumbsSwiper,
    },
  });

  /**********
   * features see more
   **********/
  let featuresBlogList = document.querySelector(".features-blog-list");
  if (featuresBlogList) {
    let seeMoreButton = document.querySelector("#see-more-button");
    if (seeMoreButton) {
      seeMoreButton.addEventListener("click", function (event) {
        // add second row
        if (!featuresBlogList.classList.contains("show-second-row")) {
          event.preventDefault();
          featuresBlogList.classList.add("show-second-row");
          // add third row
        } else if (!featuresBlogList.classList.contains("show-third-row")) {
          event.preventDefault();
          // show third row
          featuresBlogList.classList.add("show-third-row");
          // seeMoreButton.style.display = "none";
          seeMoreButton.innerHTML = "See All";
        }
      });
    }
  }

  /**********
   * cohort swiper
   **********/

  // get number of cohort years
  let cohortYears = document.querySelectorAll(".cohort-thumbnail-item").length;

  // controls
  const cohortThumbsSwiper = new Swiper(".cohort-thumbs-swiper", {
    rewind: true, // animate go to beginning
    initialSlide: cohortYears,
    slidesPerView: cohortYears,
    keyboard: {
      enabled: true,
    },
  });

  const cohortSwiper = new Swiper(".cohort-swiper", {
    rewind: true, // animate go to beginning
    initialSlide: cohortYears,
    // effect: 'fade',
    speed: 500,
    autoHeight: true,
    keyboard: {
      enabled: true,
    },
    thumbs: {
      swiper: cohortThumbsSwiper,
    },
  });

  /**********
   * swiper block (quotes on cohorts, etc)
   **********/

  // get number of cohort years
  // let swiperBlocks = document.querySelectorAll(".swiper-block").length;
  // console.log("swiperBlocks", swiperBlocks);

  // controls
  const blockSwiper = new Swiper(".block-swiper", {
    rewind: true, // animate go to beginning
    effect: "fade",
    autoplay: {
      delay: 4000,
      disableOnInteraction: true,
    },
    speed: 500,
    keyboard: {
      enabled: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  /**********
   * horizontal swiper block (movement landing page)
   **********/

  // controls
  const hsSwiper = new Swiper(".hs-swiper", {
    autoplay: {
      delay: 4000,
      disableOnInteraction: true,
    },
    speed: 500,
    keyboard: {
      enabled: true,
    },
    slidesPerView: 2,
    centeredSlides: true,
    breakpoints: {
      768: {
        slidesPerView: 5,
      },
    },
  });
});
